export default __webpack_public_path__ + "static/media/admin_icon.3567967d.svg";